import { withOpeningAndClosingBows } from './ceremony'
import type { KataDefinition } from './types'

/** Nage-no-Kata catalog — textbook labels, performance order. */
export const nageNoKata: KataDefinition = withOpeningAndClosingBows({
  id: 'nage-no-kata',
  name: 'Nage-no-Kata',
  nameJa: '投の形',
  theme: {
    from: '#1d4ed8',
    to: '#7c3aed',
    text: '#ffffff',
  },
  groups: [
    {
      id: 'te-waza',
      name: 'Te-waza',
      nameJa: '手技',
      techniques: [
        { id: 'nage-uki-otoshi', name: 'Uki-otoshi', nameJa: '浮落' },
        {
          id: 'nage-seoi-nage',
          name: 'Seoi-nage',
          nameJa: '背負投',
          searchAliases: ['Ippon-seoi-nage', 'Ippon seoi nage'],
        },
        { id: 'nage-kata-guruma', name: 'Kata-guruma', nameJa: '肩車' },
      ],
    },
    {
      id: 'koshi-waza',
      name: 'Koshi-waza',
      nameJa: '腰技',
      techniques: [
        { id: 'nage-uki-goshi', name: 'Uki-goshi', nameJa: '浮腰' },
        { id: 'nage-harai-goshi', name: 'Harai-goshi', nameJa: '払腰' },
        { id: 'nage-tsurikomi-goshi', name: 'Tsurikomi-goshi', nameJa: '釣込腰' },
      ],
    },
    {
      id: 'ashi-waza',
      name: 'Ashi-waza',
      nameJa: '足技',
      techniques: [
        { id: 'nage-okuri-ashi-harai', name: 'Okuri-ashi-harai', nameJa: '送足払' },
        { id: 'nage-sasae-tsurikomi-ashi', name: 'Sasae-tsurikomi-ashi', nameJa: '支釣込足' },
        { id: 'nage-uchi-mata', name: 'Uchi-mata', nameJa: '内股' },
      ],
    },
    {
      id: 'ma-sutemi-waza',
      name: 'Ma-sutemi-waza',
      nameJa: '真捨身技',
      techniques: [
        { id: 'nage-tomoe-nage', name: 'Tomoe-nage', nameJa: '巴投' },
        { id: 'nage-ura-nage', name: 'Ura-nage', nameJa: '裏投' },
        { id: 'nage-sumi-gaeshi', name: 'Sumi-gaeshi', nameJa: '隅返' },
      ],
    },
    {
      id: 'yoko-sutemi-waza',
      name: 'Yoko-sutemi-waza',
      nameJa: '横捨身技',
      techniques: [
        { id: 'nage-yoko-gake', name: 'Yoko-gake', nameJa: '横掛' },
        { id: 'nage-yoko-guruma', name: 'Yoko-guruma', nameJa: '横車' },
        { id: 'nage-uki-waza', name: 'Uki-waza', nameJa: '浮技' },
      ],
    },
  ],
})
